module.exports = __webpack_public_path__ + "img/wx-code.51588390.png";